<template>
  <div class="boss-tree">
    <div class="filter">
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
    </div>
    <el-tree style="height:500px;overflow: auto;" :data="treedata"
    :default-checked-keys="defaultCheckedData"
     show-checkbox default-expand-all node-key="id" :filter-node-method="filterNode" ref="tree" highlight-current :props="defaultProps"></el-tree>
    <div class="buttons">
      <el-button @click="getCheckedKeys" :disabled="disabled" type="primary">保存</el-button>
      <div style="display: none;">
        <el-button @click="getCheckedNodes">通过 node 获取</el-button>
        <el-button @click="getCheckedKeys">通过 key 获取</el-button>
        <el-button @click="setCheckedNodes">通过 node 设置</el-button>
        <el-button @click="setCheckedKeys">通过 key 设置</el-button>
        <el-button @click="resetChecked">清空</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken, removeInfo } from '@/utils/auth';
import USERAPI from '@/api/user';
export default {
  props:{
    treedata:{
      type:[Array,Object]
    },
    typeId:{
      type:[Number,String],
      default:1//1:事件2：故障
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    treedata:function(newVal,oldVal){
      this.getCheckedData(newVal);
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'selectUserTreeVo',
        label: 'name'
      },
      filterText: '',
      defaultCheckedData:[],
      disabled:true
    };
  },
  methods: {
    //获取被选中的数据
    getCheckedData(){
      let tmpData = this.treedata;
      let res = [];
      let self = this;
      function a(e){
        e.forEach(item=>{
          if(item[self.defaultProps.children].length>0){
            let child = item[self.defaultProps.children];
            a(child);
          }
          if(item.checked==true){
            res.push(item.id);
            console.log(item.id,'选中了');
          }
          // console.log(item.id,item.name);
        })
      }
      a(tmpData);
      if(res.length){
        res = this.COMM.unique(res);
      }
      this.defaultCheckedData = res;
    },
    //切换是否允许保存
    setDisabled(e){
      this.disabled = e;
    },
    filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
          },
    getCheckedNodes() {
      console.log(this.$refs.tree.getCheckedNodes());
    },
    getCheckedKeys() {
      let res = this.$refs.tree.getCheckedKeys();
      if(res.length>0){
        res = this.COMM.unique(res);
      }
      this.$emit('setTree',{typeId:this.typeId,data:res});
      console.log(res);
    },
    setCheckedNodes() {
      this.$refs.tree.setCheckedNodes([
        {
          id: 5,
          name: '二级 2-1'
        },
        {
          id: 9,
          name: '三级 1-1-1'
        }
      ]);
    },
    setCheckedKeys() {
      this.$refs.tree.setCheckedKeys([3]);
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    }
  }
};
</script>
<style scoped lang="scss">
.boss-tree {
  .filter{
    margin-bottom: 20px;
    width: 100%;
  }
  .buttons {
    margin-top: 20px;
    .el-button{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tree.vue